import JsxParser from 'react-jsx-parser'
import { get } from 'lodash'
import { GridRenderCellParams } from '@microservices/wiskey-react-table-component'

import { getExpandedPath, getPathString } from '@helpers'
import { GroupTitleType, TimeLineDTOType } from '@types'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit'

export const groupTitleCellRenderer = (data: {
  config: TimeLineDTOType
  params: GridRenderCellParams
}) => {
  const { config, params } = data

  const paths = config.mainObject?.groupTitleDisplayField || []

  const srcObj = {
    ...(params.row.value || {}),
    displayField: config.mainObject?.groupTitleDisplayField?.length
      ? get(params.row.value.groupMeta, getExpandedPath(getPathString(paths as EmbeddedObject[])))
      : params.row.value.groupKey,
  }

  if (
    config.mainObject?.groupTitleType === GroupTitleType.JS &&
    config.mainObject.groupTitleScript
  ) {
    const renderValue = new Function('srcObj', config.mainObject.groupTitleScript)

    return renderValue(srcObj, config.mainObject.groupTitleScript)
  }

  if (
    config.mainObject?.groupTitleType === GroupTitleType.JSX &&
    config.mainObject.groupTitleScript
  ) {
    return (
      <div style={{ pointerEvents: 'none' }}>
        {/* eslint-disable-next-line */}
        {/* @ts-ignore */}
        <JsxParser
          jsx={config.mainObject.groupTitleScript}
          bindings={{
            srcObj,
          }}
        />
      </div>
    )
  }

  return srcObj.displayField !== 'undefined' ? srcObj.displayField : ''
}
